import { runCalculatorFloatingAsyncAction } from "../../../Core/Calculator2/Calculator2Compatibility";
import { IForm } from "../../IForm";
import { convertToAbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";

import { IHelperFunctionsValidator } from "./IHelperFunctionsCallContext";

export class HelperFunctionsValidator implements IHelperFunctionsValidator {
    readonly #form: IForm;

    public constructor(form: IForm) {
        this.#form = form;
    }

    public validateAll(nodePaths: string[]): void {
        runCalculatorFloatingAsyncAction(() => this.#form.revalidatePaths(nodePaths.map(convertToAbsoluteModelPath)));
    }
}
